import { ColorItem } from "./types/color-item.interface";
import { ColorNames } from "./types/color-names";

export const cssColors: Record<ColorNames, ColorItem> = {
  [ColorNames.AliceBlue]: { rgb: { r: 240, g: 248, b: 255 }, hex: "#F0F8FF" },
  [ColorNames.AntiqueWhite]: {
    rgb: { r: 250, g: 235, b: 215 },
    hex: "#FAEBD7",
  },
  [ColorNames.Aqua]: { rgb: { r: 0, g: 255, b: 255 }, hex: "#00FFFF" },
  [ColorNames.Aquamarine]: { rgb: { r: 127, g: 255, b: 212 }, hex: "#7FFFD4" },
  [ColorNames.Azure]: { rgb: { r: 240, g: 255, b: 255 }, hex: "#F0FFFF" },
  [ColorNames.Beige]: { rgb: { r: 245, g: 245, b: 220 }, hex: "#F5F5DC" },
  [ColorNames.Bisque]: { rgb: { r: 255, g: 228, b: 196 }, hex: "#FFE4C4" },
  [ColorNames.Black]: { rgb: { r: 0, g: 0, b: 0 }, hex: "#000000" },
  [ColorNames.BlanchedAlmond]: {
    rgb: { r: 255, g: 235, b: 205 },
    hex: "#FFEBCD",
  },
  [ColorNames.Blue]: { rgb: { r: 0, g: 0, b: 255 }, hex: "#0000FF" },
  [ColorNames.BlueViolet]: { rgb: { r: 138, g: 43, b: 226 }, hex: "#8A2BE2" },
  [ColorNames.Brown]: { rgb: { r: 165, g: 42, b: 42 }, hex: "#A52A2A" },
  [ColorNames.BurlyWood]: { rgb: { r: 222, g: 184, b: 135 }, hex: "#DEB887" },
  [ColorNames.CadetBlue]: { rgb: { r: 95, g: 158, b: 160 }, hex: "#5F9EA0" },
  [ColorNames.Chartreuse]: { rgb: { r: 127, g: 255, b: 0 }, hex: "#7FFF00" },
  [ColorNames.Chocolate]: { rgb: { r: 210, g: 105, b: 30 }, hex: "#D2691E" },
  [ColorNames.Coral]: { rgb: { r: 255, g: 127, b: 80 }, hex: "#FF7F50" },
  [ColorNames.CornflowerBlue]: {
    rgb: { r: 100, g: 149, b: 237 },
    hex: "#6495ED",
  },
  [ColorNames.Cornsilk]: { rgb: { r: 255, g: 248, b: 220 }, hex: "#FFF8DC" },
  [ColorNames.Crimson]: { rgb: { r: 220, g: 20, b: 60 }, hex: "#DC143C" },
  [ColorNames.Cyan]: { rgb: { r: 0, g: 255, b: 255 }, hex: "#00FFFF" },
  [ColorNames.DarkBlue]: { rgb: { r: 0, g: 0, b: 139 }, hex: "#00008B" },
  [ColorNames.DarkCyan]: { rgb: { r: 0, g: 139, b: 139 }, hex: "#008B8B" },
  [ColorNames.DarkGoldenRod]: {
    rgb: { r: 184, g: 134, b: 11 },
    hex: "#B8860B",
  },
  [ColorNames.DarkGray]: { rgb: { r: 169, g: 169, b: 169 }, hex: "#A9A9A9" },
  [ColorNames.DarkGreen]: { rgb: { r: 0, g: 100, b: 0 }, hex: "#006400" },
  [ColorNames.DarkGrey]: { rgb: { r: 169, g: 169, b: 169 }, hex: "#A9A9A9" },
  [ColorNames.DarkKhaki]: { rgb: { r: 189, g: 183, b: 107 }, hex: "#BDB76B" },
  [ColorNames.DarkMagenta]: { rgb: { r: 139, g: 0, b: 139 }, hex: "#8B008B" },
  [ColorNames.DarkOliveGreen]: {
    rgb: { r: 85, g: 107, b: 47 },
    hex: "#556B2F",
  },
  [ColorNames.DarkOrange]: { rgb: { r: 255, g: 140, b: 0 }, hex: "#FF8C00" },
  [ColorNames.DarkOrchid]: { rgb: { r: 153, g: 50, b: 204 }, hex: "#9932CC" },
  [ColorNames.DarkRed]: { rgb: { r: 139, g: 0, b: 0 }, hex: "#8B0000" },
  [ColorNames.DarkSalmon]: { rgb: { r: 233, g: 150, b: 122 }, hex: "#E9967A" },
  [ColorNames.DarkSeaGreen]: {
    rgb: { r: 143, g: 188, b: 143 },
    hex: "#8FBC8F",
  },
  [ColorNames.DarkSlateBlue]: { rgb: { r: 72, g: 61, b: 139 }, hex: "#483D8B" },
  [ColorNames.DarkSlateGray]: { rgb: { r: 47, g: 79, b: 79 }, hex: "#2F4F4F" },
  [ColorNames.DarkTurquoise]: { rgb: { r: 0, g: 206, b: 209 }, hex: "#00CED1" },
  [ColorNames.DarkViolet]: { rgb: { r: 148, g: 0, b: 211 }, hex: "#9400D3" },
  [ColorNames.DeepPink]: { rgb: { r: 255, g: 20, b: 147 }, hex: "#FF1493" },
  [ColorNames.DeepSkyBlue]: { rgb: { r: 0, g: 191, b: 255 }, hex: "#00BFFF" },
  [ColorNames.DimGray]: { rgb: { r: 105, g: 105, b: 105 }, hex: "#696969" },
  [ColorNames.DimGrey]: { rgb: { r: 105, g: 105, b: 105 }, hex: "#696969" },
  [ColorNames.DodgerBlue]: { rgb: { r: 30, g: 144, b: 255 }, hex: "#1E90FF" },
  [ColorNames.FireBrick]: { rgb: { r: 178, g: 34, b: 34 }, hex: "#B22222" },
  [ColorNames.FloralWhite]: { rgb: { r: 255, g: 250, b: 240 }, hex: "#FFFAF0" },
  [ColorNames.ForestGreen]: { rgb: { r: 34, g: 139, b: 34 }, hex: "#228B22" },
  [ColorNames.Fuchsia]: { rgb: { r: 255, g: 0, b: 255 }, hex: "#FF00FF" },
  [ColorNames.Gainsboro]: { rgb: { r: 220, g: 220, b: 220 }, hex: "#DCDCDC" },
  [ColorNames.GhostWhite]: { rgb: { r: 248, g: 248, b: 255 }, hex: "#F8F8FF" },
  [ColorNames.Gold]: { rgb: { r: 255, g: 215, b: 0 }, hex: "#FFD700" },
  [ColorNames.GoldenRod]: { rgb: { r: 218, g: 165, b: 32 }, hex: "#DAA520" },
  [ColorNames.Gray]: { rgb: { r: 128, g: 128, b: 128 }, hex: "#808080" },
  [ColorNames.Green]: { rgb: { r: 0, g: 128, b: 0 }, hex: "#008000" },
  [ColorNames.GreenYellow]: { rgb: { r: 173, g: 255, b: 47 }, hex: "#ADFF2F" },
  [ColorNames.HoneyDew]: { rgb: { r: 240, g: 255, b: 240 }, hex: "#F0FFF0" },
  [ColorNames.HotPink]: { rgb: { r: 255, g: 105, b: 180 }, hex: "#FF69B4" },
  [ColorNames.IndianRed]: { rgb: { r: 205, g: 92, b: 92 }, hex: "#CD5C5C" },
  [ColorNames.Indigo]: { rgb: { r: 75, g: 0, b: 130 }, hex: "#4B0082" },
  [ColorNames.Ivory]: { rgb: { r: 255, g: 255, b: 240 }, hex: "#FFFFF0" },
  [ColorNames.Khaki]: { rgb: { r: 240, g: 230, b: 140 }, hex: "#F0E68C" },
  [ColorNames.Lavender]: { rgb: { r: 230, g: 230, b: 250 }, hex: "#E6E6FA" },
  [ColorNames.LavenderBlush]: {
    rgb: { r: 255, g: 240, b: 245 },
    hex: "#FFF0F5",
  },
  [ColorNames.LawnGreen]: { rgb: { r: 124, g: 252, b: 0 }, hex: "#7CFC00" },
  [ColorNames.LemonChiffon]: {
    rgb: { r: 255, g: 250, b: 205 },
    hex: "#FFFACD",
  },
  [ColorNames.LightBlue]: { rgb: { r: 173, g: 216, b: 230 }, hex: "#ADD8E6" },
  [ColorNames.LightCoral]: { rgb: { r: 240, g: 128, b: 128 }, hex: "#F08080" },
  [ColorNames.LightCyan]: { rgb: { r: 224, g: 255, b: 255 }, hex: "#E0FFFF" },
  [ColorNames.LightGoldenRodYellow]: {
    rgb: { r: 250, g: 250, b: 210 },
    hex: "#FAFAD2",
  },
  [ColorNames.LightGray]: { rgb: { r: 211, g: 211, b: 211 }, hex: "#D3D3D3" },
  [ColorNames.LightGreen]: { rgb: { r: 144, g: 238, b: 144 }, hex: "#90EE90" },
  [ColorNames.LightGrey]: { rgb: { r: 211, g: 211, b: 211 }, hex: "#D3D3D3" },
  [ColorNames.LightPink]: { rgb: { r: 255, g: 182, b: 193 }, hex: "#FFB6C1" },
  [ColorNames.LightSalmon]: { rgb: { r: 255, g: 160, b: 122 }, hex: "#FFA07A" },
  [ColorNames.LightSeaGreen]: {
    rgb: { r: 32, g: 178, b: 170 },
    hex: "#20B2AA",
  },
  [ColorNames.LightSkyBlue]: {
    rgb: { r: 135, g: 206, b: 250 },
    hex: "#87CEFA",
  },
  [ColorNames.LightSlateGray]: {
    rgb: { r: 119, g: 136, b: 153 },
    hex: "#778899",
  },
  [ColorNames.LightSteelBlue]: {
    rgb: { r: 176, g: 196, b: 222 },
    hex: "#B0C4DE",
  },
  [ColorNames.LightYellow]: { rgb: { r: 255, g: 255, b: 224 }, hex: "#FFFFE0" },
  [ColorNames.Lime]: { rgb: { r: 0, g: 255, b: 0 }, hex: "#00FF00" },
  [ColorNames.LimeGreen]: { rgb: { r: 50, g: 205, b: 50 }, hex: "#32CD32" },
  [ColorNames.Linen]: { rgb: { r: 250, g: 240, b: 230 }, hex: "#FAF0E6" },
  [ColorNames.Magenta]: { rgb: { r: 255, g: 0, b: 255 }, hex: "#FF00FF" },
  [ColorNames.Maroon]: { rgb: { r: 128, g: 0, b: 0 }, hex: "#800000" },
  [ColorNames.MediumAquaMarine]: {
    rgb: { r: 102, g: 205, b: 170 },
    hex: "#66CDAA",
  },
  [ColorNames.MediumBlue]: { rgb: { r: 0, g: 0, b: 205 }, hex: "#0000CD" },
  [ColorNames.MediumOrchid]: { rgb: { r: 186, g: 85, b: 211 }, hex: "#BA55D3" },
  [ColorNames.MediumPurple]: {
    rgb: { r: 147, g: 112, b: 219 },
    hex: "#9370DB",
  },
  [ColorNames.MediumSeaGreen]: {
    rgb: { r: 60, g: 179, b: 113 },
    hex: "#3CB371",
  },
  [ColorNames.MediumSlateBlue]: {
    rgb: { r: 123, g: 104, b: 238 },
    hex: "#7B68EE",
  },
  [ColorNames.MediumSpringGreen]: {
    rgb: { r: 0, g: 250, b: 154 },
    hex: "#00FA9A",
  },
  [ColorNames.MediumTurquoise]: {
    rgb: { r: 72, g: 209, b: 204 },
    hex: "#48D1CC",
  },
  [ColorNames.MediumVioletRed]: {
    rgb: { r: 199, g: 21, b: 133 },
    hex: "#C71585",
  },
  [ColorNames.MidnightBlue]: { rgb: { r: 25, g: 25, b: 112 }, hex: "#191970" },
  [ColorNames.MintCream]: { rgb: { r: 245, g: 255, b: 250 }, hex: "#F5FFFA" },
  [ColorNames.MistyRose]: { rgb: { r: 255, g: 228, b: 225 }, hex: "#FFE4E1" },
  [ColorNames.Moccasin]: { rgb: { r: 255, g: 228, b: 181 }, hex: "#FFE4B5" },
  [ColorNames.NavajoWhite]: { rgb: { r: 255, g: 222, b: 173 }, hex: "#FFDEAD" },
  [ColorNames.Navy]: { rgb: { r: 0, g: 0, b: 128 }, hex: "#000080" },
  [ColorNames.OldLace]: { rgb: { r: 253, g: 245, b: 230 }, hex: "#FDF5E6" },
  [ColorNames.Olive]: { rgb: { r: 128, g: 128, b: 0 }, hex: "#808000" },
  [ColorNames.OliveDrab]: { rgb: { r: 107, g: 142, b: 35 }, hex: "#6B8E23" },
  [ColorNames.Orange]: { rgb: { r: 255, g: 165, b: 0 }, hex: "#FFA500" },
  [ColorNames.OrangeRed]: { rgb: { r: 255, g: 69, b: 0 }, hex: "#FF4500" },
  [ColorNames.Orchid]: { rgb: { r: 218, g: 112, b: 214 }, hex: "#DA70D6" },
  [ColorNames.PaleGoldenRod]: {
    rgb: { r: 238, g: 232, b: 170 },
    hex: "#EEE8AA",
  },
  [ColorNames.PaleGreen]: { rgb: { r: 152, g: 251, b: 152 }, hex: "#98FB98" },
  [ColorNames.PaleTurquoise]: {
    rgb: { r: 175, g: 238, b: 238 },
    hex: "#AFEEEE",
  },
  [ColorNames.PaleVioletRed]: {
    rgb: { r: 219, g: 112, b: 147 },
    hex: "#DB7093",
  },
  [ColorNames.PapayaWhip]: { rgb: { r: 255, g: 239, b: 213 }, hex: "#FFEFD5" },
  [ColorNames.PeachPuff]: { rgb: { r: 255, g: 218, b: 185 }, hex: "#FFDAB9" },
  [ColorNames.Peru]: { rgb: { r: 205, g: 133, b: 63 }, hex: "#CD853F" },
  [ColorNames.Pink]: { rgb: { r: 255, g: 192, b: 203 }, hex: "#FFC0CB" },
  [ColorNames.Plum]: { rgb: { r: 221, g: 160, b: 221 }, hex: "#DDA0DD" },
  [ColorNames.PowderBlue]: { rgb: { r: 176, g: 224, b: 230 }, hex: "#B0E0E6" },
  [ColorNames.Purple]: { rgb: { r: 128, g: 0, b: 128 }, hex: "#800080" },
  [ColorNames.RebeccaPurple]: {
    rgb: { r: 102, g: 51, b: 153 },
    hex: "#663399",
  },
  [ColorNames.Red]: { rgb: { r: 255, g: 0, b: 0 }, hex: "#FF0000" },
  [ColorNames.RosyBrown]: { rgb: { r: 188, g: 143, b: 143 }, hex: "#BC8F8F" },
  [ColorNames.RoyalBlue]: { rgb: { r: 65, g: 105, b: 225 }, hex: "#4169E1" },
  [ColorNames.SaddleBrown]: { rgb: { r: 139, g: 69, b: 19 }, hex: "#8B4513" },
  [ColorNames.Salmon]: { rgb: { r: 250, g: 128, b: 114 }, hex: "#FA8072" },
  [ColorNames.SandyBrown]: { rgb: { r: 244, g: 164, b: 96 }, hex: "#F4A460" },
  [ColorNames.SeaGreen]: { rgb: { r: 46, g: 139, b: 87 }, hex: "#2E8B57" },
  [ColorNames.SeaShell]: { rgb: { r: 255, g: 245, b: 238 }, hex: "#FFF5EE" },
  [ColorNames.Sienna]: { rgb: { r: 160, g: 82, b: 45 }, hex: "#A0522D" },
  [ColorNames.Silver]: { rgb: { r: 192, g: 192, b: 192 }, hex: "#C0C0C0" },
  [ColorNames.SkyBlue]: { rgb: { r: 135, g: 206, b: 235 }, hex: "#87CEEB" },
  [ColorNames.SlateBlue]: { rgb: { r: 106, g: 90, b: 205 }, hex: "#6A5ACD" },
  [ColorNames.SlateGray]: { rgb: { r: 112, g: 128, b: 144 }, hex: "#708090" },
  [ColorNames.Snow]: { rgb: { r: 255, g: 250, b: 250 }, hex: "#FFFAFA" },
  [ColorNames.SpringGreen]: { rgb: { r: 0, g: 255, b: 127 }, hex: "#00FF7F" },
  [ColorNames.SteelBlue]: { rgb: { r: 70, g: 130, b: 180 }, hex: "#4682B4" },
  [ColorNames.Tan]: { rgb: { r: 210, g: 180, b: 140 }, hex: "#D2B48C" },
  [ColorNames.Teal]: { rgb: { r: 0, g: 128, b: 128 }, hex: "#008080" },
  [ColorNames.Thistle]: { rgb: { r: 216, g: 191, b: 216 }, hex: "#D8BFD8" },
  [ColorNames.Tomato]: { rgb: { r: 255, g: 99, b: 71 }, hex: "#FF6347" },
  [ColorNames.Turquoise]: { rgb: { r: 64, g: 224, b: 208 }, hex: "#40E0D0" },
  [ColorNames.Violet]: { rgb: { r: 238, g: 130, b: 238 }, hex: "#EE82EE" },
  [ColorNames.Wheat]: { rgb: { r: 245, g: 222, b: 179 }, hex: "#F5DEB3" },
  [ColorNames.White]: { rgb: { r: 255, g: 255, b: 255 }, hex: "#FFFFFF" },
  [ColorNames.WhiteSmoke]: { rgb: { r: 245, g: 245, b: 245 }, hex: "#F5F5F5" },
  [ColorNames.Yellow]: { rgb: { r: 255, g: 255, b: 0 }, hex: "#FFFF00" },
  [ColorNames.YellowGreen]: { rgb: { r: 154, g: 205, b: 50 }, hex: "#9ACD32" },
};
